export default __webpack_public_path__ + "static/media/payout.cf0602d9.svg";